import { EventEmitter } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { detailSupplierScreenValidity } from "./detailSupplierScreenValidity";
import { SaveStepParam } from "./SaveStepParam";
import { SharedDataService } from "../../../all-services";
import { SVGIcon } from '@progress/kendo-svg-icons'; // "@progress/kendo-angular-icons";


export class StepLabelIcon {
  public label?:string;
  public labelCod?:string;
  public icon?:string;
  public iconClass?:string;
  public imgSrc?:string;
  public svgIcon?: SVGIcon | undefined;

}

export class SupplierScreenStep {
    public labelCod:string;
    public label: string;
    public icon: string;
    public svgIcon?: SVGIcon;
    public iconClass: string;
    public imgSrc: string;
    public index: number;
    public disabled: boolean = false;
    public screenValidity!: detailSupplierScreenValidity;
    public validate(): any { };
    public showSaveButton():any{};
    public saveStep: Subject<SaveStepParam> = new Subject<SaveStepParam>();
    public stepSaved: EventEmitter<SaveStepParam>;
    public canModifySupplier():any{};
    public supplierReloaded : Subject<number> = new Subject<number>();
    private _isEditing:boolean = false;
    public get isEditing():boolean {
      return this._isEditing;
    }
    public set isEditing(value:boolean) {
      if (value!= this._isEditing){
        this._isEditing = value;
        this._iseditinSubject.next(value);
      }
    }

    public onUndoScreen? :()=>Promise<void> ;

    private _iseditinSubject:Subject<boolean>= new Subject<boolean>();
    public editingChange:Observable<boolean>;
    public raiseCheckValidity:Subject<boolean | void | undefined> = new Subject<boolean | void | undefined>();

    public onValidityChecked:EventEmitter<detailSupplierScreenValidity> = new EventEmitter<detailSupplierScreenValidity>();

    constructor(
      public sharedDataSvc: SharedDataService,
      item:StepLabelIcon,
      i:number,
      public isReadonly:()=>boolean)
      {
        this.screenValidity = new detailSupplierScreenValidity(this.sharedDataSvc,i);
        this.stepSaved = new EventEmitter<SaveStepParam>();
        this.editingChange = this._iseditinSubject.asObservable();
        this.labelCod = item.labelCod || '';
        this.label = item.label;
        this.icon = item.icon;
        this.svgIcon = item.svgIcon;
        this.iconClass = item.iconClass;
        this.imgSrc = item.imgSrc;
        this.index = i;
    }
  }